<div class="payment-error-warning">
  <div class="payment-error-icon">
    <img src="assets/icons/orange-warning-icon.svg" alt="Error icon">
  </div>
  <p> {{ message | translate }} </p>
</div>
